import AnalyticsIcon from '@mui/icons-material/Analytics';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import StatCard from '../../components/StatCard';
import Copyright from '../../internals/components/Copyright';
import AnalyticsCharts from './AnalyticsCharts';

export default function AnalyticsGrid({
  trips = [],
  data_points = [],
  total_packages = 0,
  total_drivers = 0,
  drivers_available = 0,
  total_packages_collected = 0,
  total_sellers = 0,
  packages_by_hour = {},
  drivers_by_hour = {},
  collected_by_hour = {}
}) {
  const hasTripsData = trips && trips.length > 0;
  const hasDataPointsData = data_points && data_points.length > 0;
  const hasAnyData = hasTripsData || hasDataPointsData;

  // Calcular estatísticas para StatCards
  const generateStatCards = () => {
    const cards = [];

    if (hasTripsData) {
      // Volumes Entregues
      cards.push({
        title: 'Volumes Entregues',
        value: total_packages.toString(),
        interval: 'Hoje',
        trend: total_packages > 0 ? 'up' : 'neutral',
        data: Array.from({ length: 30 }, () => Math.floor(Math.random() * total_packages + 1) || 1)
      });

      // Veículos Chegada - Opção A: "15 de 20"
      const driversFinished = total_drivers - drivers_available;
      const driversPercentage = total_drivers > 0 ? (driversFinished / total_drivers) * 100 : 0;
      cards.push({
        title: 'Veículos Chegada',
        value: `${driversFinished} de ${total_drivers}`,
        interval: 'Hoje',
        trend: driversPercentage >= 75 ? 'up' : driversPercentage >= 50 ? 'neutral' : 'down',
        data: Array.from({ length: 30 }, () => Math.floor(Math.random() * total_drivers + 1) || 1)
      });
    }

    if (hasDataPointsData) {
      // Volumes Coletados
      cards.push({
        title: 'Volumes Coletados',
        value: total_packages_collected.toString(),
        interval: 'Hoje',
        trend: total_packages_collected > 0 ? 'up' : 'neutral',
        data: Array.from({ length: 30 }, () => Math.floor(Math.random() * total_packages_collected + 1) || 1)
      });

      // Sellers
      cards.push({
        title: 'Sellers',
        value: total_sellers.toString(),
        interval: 'Hoje',
        trend: total_sellers > 0 ? 'up' : 'neutral',
        data: Array.from({ length: 30 }, () => Math.floor(Math.random() * total_sellers + 1) || 1)
      });
    }

    return cards;
  };

  const statCards = generateStatCards();

  if (!hasAnyData) {
    return (
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            flexDirection: 'column'
          }}
        >
          <Alert severity="info" sx={{ maxWidth: 600, textAlign: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <AnalyticsIcon sx={{ mr: 1, fontSize: 'large' }} />
              <Typography variant="h6">
                Nenhum dado disponível até o momento
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              Os dados analíticos aparecerão aqui quando houver atividade de entrega e coleta.
            </Typography>
          </Alert>
        </Box>
        <Copyright sx={{ my: 4 }} />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* StatCards */}
      {statCards.length > 0 && (
        <>
          <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
            Métricas do Dia
          </Typography>
          <Grid
            container
            spacing={2}
            columns={12}
            sx={{ mb: (theme) => theme.spacing(4) }}
          >
            {statCards.map((card, index) => (
              <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
                <StatCard {...card} />
              </Grid>
            ))}
          </Grid>
        </>
      )}

      {/* Gráficos */}
      <AnalyticsCharts
        hasTripsData={hasTripsData}
        hasDataPointsData={hasDataPointsData}
        packages_by_hour={packages_by_hour}
        drivers_by_hour={drivers_by_hour}
        collected_by_hour={collected_by_hour}
      />

      <Copyright sx={{ my: 4 }} />
    </Box>
  );
} 